import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { driver } from "driver.js";

@Component({
  selector: 'vex-meal-info',
  templateUrl: './meal-info.component.html',
  styleUrls: ['./meal-info.component.scss']
})
export class MealInfoComponent implements OnInit {
  @Input() data: any;
  activeTab: string = 'Breakfast';
  colazione = [];
  pranzo = [];
  cena = [];

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService, @Inject(MAT_DIALOG_DATA) public datas: any) {
    this.data = datas.data;
  }

  ngOnInit() {
    console.debug(this.data)
    this.colazione = this.data.filter(x => x.mealType === 'colazione');
    this.pranzo = this.data.filter(x => x.mealType === 'pranzo');
    this.cena = this.data.filter(x => x.mealType === 'cena');
    console.debug('colazione', this.colazione)
    console.debug('pranzo', this.pranzo)
    console.debug('cena', this.cena)
    setTimeout(() => {
      localStorage.getItem('tourMealComposeShowed') ? null : this.startTour();
    }, 1000);
  }

  closeModal() {
    this.dialogRef.close();
  }

  selectTab(tab: string){
    this.activeTab = tab;
  }

  startTour(): void {
    localStorage.setItem('tourMealComposeShowed', 'true');

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.tabs-tutorial-3', popover: { title: this.translate.instant('TUTORIALS.meal-plan.createMealIndependentlyTitle'), description: this.translate.instant('TUTORIALS.meal-plan.createMealIndependentlyDescription'), side: 'bottom' } },
        { element: '.info-box', popover: { title: this.translate.instant('TUTORIALS.meal-plan.viewMacronutrientsTitle2'), description: this.translate.instant('TUTORIALS.meal-plan.viewMacronutrientsDescription2'), side: 'bottom' } },
        { element: '.carbo-focus-tutorial', popover: { title: this.translate.instant('TUTORIALS.meal-plan.exploreAvailableOptionsTitle'), description: this.translate.instant('TUTORIALS.meal-plan.exploreAvailableOptionsDescription') } }
      ]
    });

    driverObj.drive();
  }

}

